import React from 'react';
import { ArrowLeft, Home } from 'lucide-react';
import Button from '../common/Button';

const Navigation = ({ 
  title, 
  subtitle, 
  showBackButton = false, 
  onBack, 
  actions = [],
  breadcrumbs = []
}) => {
  return (
    <div className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {showBackButton && (
            <Button
              variant="ghost"
              size="sm"
              icon={ArrowLeft}
              onClick={onBack}
            >
              Înapoi
            </Button>
          )}
          
          <div>
            {/* Breadcrumbs */}
            {breadcrumbs.length > 0 && (
              <nav className="flex items-center space-x-2 text-sm text-gray-500 mb-1">
                <Home className="w-4 h-4" />
                {breadcrumbs.map((crumb, index) => (
                  <React.Fragment key={index}>
                    <span>/</span>
                    {crumb.href ? (
                      <button 
                        onClick={() => crumb.onClick?.()}
                        className="hover:text-gray-700 transition-colors"
                      >
                        {crumb.label}
                      </button>
                    ) : (
                      <span className={index === breadcrumbs.length - 1 ? 'text-gray-900 font-medium' : ''}>
                        {crumb.label}
                      </span>
                    )}
                  </React.Fragment>
                ))}
              </nav>
            )}
            
            {/* Title */}
            <h1 className="text-2xl font-bold text-gray-900">
              {title}
            </h1>
            
            {/* Subtitle */}
            {subtitle && (
              <p className="text-gray-600 mt-1">
                {subtitle}
              </p>
            )}
          </div>
        </div>
        
        {/* Actions */}
        {actions.length > 0 && (
          <div className="flex items-center space-x-3">
            {actions.map((action, index) => (
              <Button
                key={index}
                variant={action.variant || 'primary'}
                size={action.size || 'md'}
                icon={action.icon}
                onClick={action.onClick}
                disabled={action.disabled}
                loading={action.loading}
              >
                {action.label}
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Navigation;